<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Especialidad' : tipo === 'crear' ? 'Crear Especialidad' : 'Ficha de la Especialidad' }}</span></h3>
          </v-card-title>
          <v-card-text>

                        <v-flex v-if="tipo === 'ver'" xs12 align-center justify-center layout text-xs-center>
                        </v-flex>

                           <v-text-field
                            :disabled="tipo === 'ver'"
                            ref="name"
                            prepend-icon="location_city"
                            v-model="form.name"
                            :rules="[v => !!v || 'El nombre es requerido']"
                            :error-messages="errName"
                            label="Nombre"
                            required
                            ></v-text-field>

                            <v-autocomplete
                            :disabled="tipo === 'ver'"
                            ref="subespecialidad"
                            prepend-icon="list"
                            item-text="name"
                            item-value="id"
                            :items="datos"
                            v-model="form.specialty_id"
                            label="Sub-Especialidad"
                          ></v-autocomplete>

          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="tipo !== 'ver'" :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : tipo === 'crear' ? 'Crear': 'Ver' }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'

export default {
  name: 'form-specialty-view',

  props: {
    tipo: {
      type: String,
      required: true
    },
    datos: {
      type: Array,
      required: true
    }
  },

  watch: {
    datos(v) {
      this.$refs.form.resetValidation()
      if (this.tipo == "crear") {
        Object.assign(this.form, this.formOld)
      }else {
        Object.assign(this.form, v)
      }
    }
  },

  data: () => ({
    errName: [],
    valid: false,
    loading: false,
    form: new Form({
        name: '',
        spcialty_id: null,
    }),
    formOld:{
        name: '',
        spcialty_id: null,
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.submitFormSpecialties()
      }
    },

    async submitFormSpecialties () {
      try {
        if (this.tipo == 'crear') {
          const { data } = await axios.post('/api/specialties/admin/create_specialty', this.form)
          this.cerrarDialog(data)
        }else {
          const { data } = await axios.patch('/api/specialties/admin/update_specialty', this.form)
          this.cerrarDialog(data)
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.loading = false
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.code) {
            this.$refs.code.focus()
            //this.errName.push('name ya existe')
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.code[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }

    },

    cerrarDialog (data) {
      this.$emit('closeDialogSpecialty', data)
      this.$nextTick(() => {
        //this.errTit = []
        this.$refs.form.resetValidation()
        this.loading = false
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/formSpecialties.vue